'use client';

import React from 'react';
import Link from 'next/link';
import { orderBy } from 'es-toolkit/compat';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Icon from '@mui/material/Icon';

import useLocalization from '@/hooks/useLocalization';
import { getNavigationLinkProps } from '@/services/navigation/utils';

import styles from './Navigation.module.scss';
import { shouldDisableExternalLink } from '@/utils/linkHelpers';

export const NavLink = ({
  children,
  block,
  company,
  style = undefined,
  guestBookSlug = 'guest',
  isKioskMode = false,
}) => {
  const { locale } = useLocalization();
  const { isLocal, url, linkProps } = getNavigationLinkProps({
    settings: block.settings,
    locale,
    company,
    guestBookSlug,
  });

  const isLinkDisabled = shouldDisableExternalLink(url, isKioskMode);

  if (isLocal) {
    return (
      <Link {...linkProps} style={style}>
        {children}
      </Link>
    );
  }

  if (isLinkDisabled) {
    return null;
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" style={style}>
      {children}
    </a>
  );
};

const Navigation = ({
  settings,
  section,
  company,
  guestBookSlug,
  isKioskMode,
}) => {
  const orderedBlocks = orderBy(section.blocks, (b, i) =>
    b.settings.hasOwnProperty('index') ? b.settings.index : i,
  );

  return (
    <ul className={styles.container}>
      {orderedBlocks.map((block) => {
        return (
          <li className={styles.menuItem} key={block.id}>
            <NavLink
              block={block}
              company={company}
              guestBookSlug={guestBookSlug}
              style={{
                backgroundColor: section.settings.backgroundColor,
                borderColor: settings.whistle_guest_primary_button_color,
                color: settings.whistle_guest_primary_button_color,
              }}
              isKioskMode={isKioskMode}
            >
              {block.settings.icon && <Icon>{block.settings.icon}</Icon>}
              <span className={styles.item}>{block.plain_text}</span>
              <ChevronRight />
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default Navigation;
